export const COGNITO = {
  USER_POOL_ID: "eu-central-1_5yJ9fLsgt",
  REGION: "eu-central-1",
  APP_CLIENT_ID: "10o8tcmervg4theroc6ti6ghf7"
};
